import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Button, Alert } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import FormInput from 'components/forms/FormInput';
import FormInputPassword from 'components/forms/FormInputPassword';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormErrors from 'components/forms/FormErrors';

class DashboardInitCars extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      username: '',
      password: '',
      location: null,
    };
  }

  closeForm = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showForm: false });
  };

  updateUsername = (name, username) => {
    this.setState({ username });
  };

  updatePassword = (name, password) => {
    this.setState({ password });
  };

  updateLocation = (name, location) => {
    this.setState({ location });
  };

  formSubmit = e => {
    e.preventDefault();
    const { username, password, location, onSubmit } = this.state;
    if (username && password && location) {
      onSubmit({ username, password, location });
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      formStatus,
      history,
    } = this.props;
    const { showForm, username, password, location } = this.state;

    return (
      <div class="jumbotron">
        <Grid fluid class="m-b-20 m-t-20">
          <Row>
            <Col lg={6} class="bg-white">
              <div class="padding-30 text-center">Nice video here</div>
            </Col>
            <Col lg={6}>
              <div class="card card-transparent">
                <div class="card-header">
                  <div class="card-title">{messages.getting_started}</div>
                  {showForm ? (
                    <div class="card-controls">
                      <ul>
                        <li>
                          <a href="#closeForm" onClick={this.closeForm}>
                            <i class="fa fa-times" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : null}
                </div>
                <div class="card-block">
                  <AnimateHeight duration={500} height={showForm ? 0 : 'auto'}>
                    <h3>{messages.cars_to_sell}</h3>
                    <p>{messages.your_business_is_car_sales_but_there_are_no_cars_create_yourself_or_use_import}</p>
                    <div class="text-right p-t-15">
                      <Button class="m-r-10" onClick={() => history.push(appIntl.urlPrefix + 'account/cars')}>
                        <i class="fa fa-car m-r-10" /> {messages.create_manually}
                      </Button>
                      <Button bsStyle="primary" onClick={() => this.setState({ showForm: true })}>
                        <i class="fa fa-upload m-r-10" /> {messages.import}
                      </Button>
                    </div>
                  </AnimateHeight>

                  <AnimateHeight duration={500} height={showForm ? 'auto' : 0}>
                    <div>
                      <h3>{messages.car_import}</h3>
                      <p>
                        {messages.most_car_dealers_use_mobilede_enter_your_interface_username_and_password_to_import}
                      </p>

                      {formStatus.response !== null ? (
                        <div class="m-t-20">
                          <Alert bsStyle="info">
                            <FormattedMessage
                              id="we_will_import_count_cars_for_this_username"
                              values={{ count: formStatus.response.count }}
                            />
                          </Alert>
                        </div>
                      ) : (
                        <form method="post" onSubmit={this.formSubmit} class="m-t-20">
                          <FormErrors formStatus={formStatus} />

                          <div class="form-group-attached">
                            <FormInput
                              label={messages.mobile_de_username}
                              name="username"
                              onChange={this.updateUsername}
                              disabled={formStatus.pending}
                            />
                            <FormInputPassword
                              label={messages.mobile_de_password}
                              name="password"
                              onChange={this.updatePassword}
                              disabled={formStatus.pending}
                            />
                            <FormAutocomplete
                              label={messages.location}
                              name="location"
                              value={location}
                              onChange={this.updateLocation}
                              returnValueObject
                              autocompleteType="companyLocation"
                              urlFilters={{ filters: { parent: 'true' } }}
                              complete
                              disabled={formStatus.pending}
                            />
                          </div>

                          <div class="text-right m-t-15">
                            <Button
                              bsSize="lg"
                              disabled={formStatus.pending}
                              type="submit"
                              bsStyle={username || password ? 'primary' : 'default'}
                            >
                              <i
                                class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')}
                              />{' '}
                              {messages.import}
                            </Button>
                          </div>
                        </form>
                      )}
                    </div>
                  </AnimateHeight>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.mobiledeImport,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: args => {
      formStatusDispatchHelper('mobiledeImport', '/api/cars/import.json', args, 'post', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DashboardInitCars)
  )
);
